import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserManualComponent } from './user-manual.component';

@NgModule({
  declarations: [UserManualComponent],
  imports: [
    CommonModule
  ]
})
export class UserManualModule { }
